import { memo } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

interface PageLoadingSpinnerProps {
  title: string
}

export const PageLoadingSpinner = memo(function PageLoadingSpinner({
  title
}: PageLoadingSpinnerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 4,
        alignItems: 'center',
        minHeight: '100vh'
      }}
    >
      <CircularProgress size="4rem" thickness={2} />
      <Typography variant="body2">{title}</Typography>
    </Box>
  )
})
